<template>
  <draggable v-model="widgets" :options="{group:'widgets', draggable, handle: '.arrow-move'}" @start="drag=true">
    <component v-for="widget in widgets" :is="widget.name" v-bind:key="widget.id" :mode="widget.type"></component>
  </draggable>
</template>
<script>
  import draggable from 'vuedraggable';
  import ProfileParticipant from '@/components/widgets/ProfileParticipant';
  import AssessmentAndOutcomes from '@/components/widgets/AssessmentAndOutcomes';
  import Assingment from '@/components/widgets/Assingment';
  import ActivitiesAndServices from '@/components/widgets/ActivitiesAndServices';
  import CaseNotes from '@/components/widgets/CaseNotes';
  import ActivityFeed from '@/components/widgets/ActivityFeed';
  import CaseloadSummary from '@/components/widgets/CaseloadSummary';
  import Calendar from '@/components/widgets/Calendar';
  import GeneralForms from '@/components/widgets/GeneralForms';
  import OrganizationForms from '@/components/widgets/OrganizationForms';
  import TopReports from '@/components/widgets/TopReports';
  import ReferralFeed from '@/components/widgets/ReferralFeed';

  export default {
    props: ['name', 'type', 'draggable'],

    components: {
      draggable,
      ProfileParticipant,
      AssessmentAndOutcomes,
      Assingment,
      ActivitiesAndServices,
      CaseNotes,
      ActivityFeed,
      CaseloadSummary,
      Calendar,
      GeneralForms,
      OrganizationForms,
      TopReports,
      ReferralFeed
    },

    data() {
      return {
        widgets: this.name,
        types: this.type
      }
    },

    watch: {
      widgets: function(data) {
        this.$emit('passWidgets', [
          this.types, data
        ]);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Widget.vue?6fc4f84d